import classNames from 'classnames'
import TextareaAutosize from 'react-autosize-textarea'

export const FormTextArea = ({field, form: {touched, errors}, ...props}) => {
  const hasError = touched[field.name] && errors[field.name]
  const classes = classNames(props.className, 'form-control', {'field-with-error': hasError})
  const groupClass = `donate-form-group-${field.name.replace('_', '-')}`

  return <div className={classNames('form-group', groupClass)}>
    <label className='control-label sr-only' htmlFor={field.name}>{props.placeholder}</label>
    <TextareaAutosize id={field.name} className={classes} {...field} {...props} />
    {hasError && <span className='help-inline'>{errors[field.name]}</span>}
  </div>
}
